import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/translation/countries/translation.countries.query.gql"
import type {
  TranslationCountriesQuery,
  TranslationCountriesQueryVariables,
} from "@/v2-backoffice-client/translation/countries/__types__/translation.countries.query"

type Options = QueryHookOptions<
  TranslationCountriesQuery,
  TranslationCountriesQueryVariables
>

export function useTranslationCountriesQuery(options?: Options) {
  return useQuery<
    TranslationCountriesQuery,
    TranslationCountriesQueryVariables
  >(query, options)
}
